import { createAction } from 'utils/redux'

export const validatePlaybook = (
  playbook,
  blocksById,
  connectedCalendars,
  orgTeams
) =>
  createAction({
    type: 'VALIDATE_PLAYBOOK',
    playbook,
    blocksById,
    connectedCalendars,
    orgTeams,
  })
